import React from 'react';
import AnnunciLista from './AnnunciLista';

function AnnunciAssistenteFamiliare() {
    return <AnnunciLista conContatto={false}/>
}

export default AnnunciAssistenteFamiliare
